import React, { Suspense, lazy, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import fontana from "../../Assets/fontana-logo.png";
import lumina from "../../Assets/luminar-logo.png";
import Cerulean from "../../Assets/cerulean-logo.png";
import Home1 from "./Home1";
import Home2 from "./Home2";
import Home3 from "./Home3";
import Home4 from "./Home4";
import HomeBanner from "./HomeBanner";
import HomeSocial from "./HomeSocial.js";
import Type from "./Type";

const Particle = lazy(() => import("../Particle"));

function Home() {
  const [hoveredText] = useState("");

  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Suspense fallback={null}>
          <Particle />
        </Suspense>
        <Container className="home-content">
          <Row>

            <Col md={6} className="home-header">
              <div className="heading-ease-illuminated ps-3">
                " A Fountain to a realm where every trade is a growth, where your activity directly earns you rewards."
              </div>

              <p className="poppins-light ps-3">
                A realm where your everyday trading does more than just exchange assets. It fuels vibrant FONTANA ecosystem and unlocks a world of possibilities.
                Fontana is a <b className="purple"> Utility Token</b> designed to reward and incentivize you, <b className="purple"> the traders</b>, who are the lifeblood of our ecosystem.
              </p>

              <div className="p-5 text-start">
                <Type />
              </div>
            </Col>

            <Col md={6} className="home-main pb-3">
              <Container fluid>
                <Row>
                  <Col className="p-3 d-flex flex-column align-items-center justify-content-center">
                    <div className="fontana position-relative" style={{ zIndex: 1 }}>
                      <img src={fontana} alt="Fontana logo" className="site-logo component-img" />
                    </div>
                    <p className="mt-2 mb-0">FONTANA</p>
                  </Col>
                  <Col className="p-3 d-flex flex-column align-items-center justify-content-center">
                    <img src={lumina} alt="Lumina logo" className="site-logo component-img" style={{ cursor: "pointer" }} />
                    <p className="mt-2 mb-0">LUMINA</p>
                  </Col>
                  <Col className="p-3 d-flex flex-column align-items-center justify-content-center">
                    <img src={Cerulean} alt="Cerulean logo" className="site-logo component-img" />
                    <p className="mt-2 mb-0">CERULEAN</p>
                  </Col>
                </Row>
                <Row>
                  <Col md={12} className="text-center mt-3">
                    <div id="hovered-text-display">{hoveredText}</div>
                  </Col>

                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <Home1 />
      <HomeBanner />
      <Home3/>
      <Home2 />
      <Home4/>      
      
      <HomeSocial/>
    </section>
  );
}

export default Home;
